import React, { useContext, useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { BsWhatsapp } from "react-icons/bs";
import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { FaRegUserCircle } from "react-icons/fa";
import { CiMoneyBill } from "react-icons/ci";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem('theme')


  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `Play ludo and Win Cash daily
24x7 live Support
Commission Charge 5%
Referral Bouns 3% on All Games
Instant withdrawal Via UPI/Bank
https://nkadda.com/login/${user.referral_code}
Register Now , My refer code is ${user.referral_code}`


  // language 


  const translations = {
    hi: {
      referral: 'आपकी रेफरल कमाई',
      referPerson: 'आमंत्रित किये दोस्त | ',
      referEarn: 'रेफरल कमाई  ',
      referCode: 'रेफरल कोड ',
    },
    en: {
      referral: 'Lifetime Earnings',
      referPerson: 'Referred Players',
      referEarn: 'Referral Earning',
      referCode: 'Referral Code',
    },
  };

  // change theme 

  const styles = {
    backgroundColor: theme === 'light' ? '#fff' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
  };


  return (
    <>
      {/* <Header user={user} /> */}
      <div style={styles}>


        <div
          className="leftContainer mb_space_1"
          style={{ ...styles, minHeight: "100vh", height: "100%" }}
        >

          <section className="refer_page_main_section ">

            <div>
              <h3 className="mb-1 fs-20"> <b> Refer </b> </h3>
              <p>You can earn more more real money doing refer to your friends.</p>
            </div>
            <div className=" mb-5">
              {/* <img className="w-50 refral" src="../images/referral-signup-bonus-new.png"/> */}
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings text-dark text-left">{translations[language].referCode}</h2>
              </div>
              <div>
                <div className="Refer_code" >
                  <h3 className="text-dark" style={{ ...styles, border: "1px solid" }}>{user.referral_code}</h3>

                  <button onClick={(e) => copyCode(e)}>Copy</button>
                </div>
                <div className="or_div">
                  {" "}

                </div>
                <div className="whatsapp_share_btn">
                  <a
                    // href={`whatsapp://send?text=Hi%20Friends%2C%20Play%20NKADDA%20Ludo%20and%20earn%2010000%20daily.%20Download%20Indian%20App%20KK%20Adda%0A%20%20%E0%A4%AC%E0%A4%AE%E0%A5%8D%E0%A4%AE%E0%A4%AB%E0%A4%B0%20%20%E0%A4%A7%E0%A4%AE%E0%A4%BE%E0%A4%95%E0%A4%BE%20%E0%A4%91%E0%A4%AB%E0%A4%B0%20%20%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%20%E0%A4%86%20%E0%A4%97%E0%A4%AF%E0%A4%BE%20%E0%A4%B9%E0%A5%88%20%E0%A4%AD%E0%A4%BE%E0%A4%B0%E0%A4%A4%20%E0%A4%95%E0%A4%BE%20%E0%A4%AA%E0%A4%B9%E0%A4%B2%E0%A4%BE%20%E0%A4%90%E0%A4%B8%E0%A4%BE%20%E0%A4%97%E0%A5%87%E0%A4%AE%E0%A4%BF%E0%A4%82%E0%A4%97%20%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A5%89%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%E0%A4%9C%E0%A4%B9%E0%A4%BE%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%8B%20win%20%E0%A4%AA%E0%A4%B0%20%E0%A4%B0%E0%A5%88%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%AE%E0%A5%80%E0%A4%B6%E0%A4%A8%204%25%20%E0%A4%A6%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%E0%A4%9C%E0%A4%BE%E0%A4%8F%E0%A4%97%E0%A4%BE%20%E0%A4%85%E0%A4%97%E0%A4%B0%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%87%20%E0%A4%B0%E0%A5%87%E0%A4%AB%E0%A4%B0%20%E0%A4%B8%E0%A5%87%20%E0%A4%97%E0%A5%87%E0%A4%AE%20%E0%A4%96%E0%A5%87%E0%A4%B2%E0%A4%A4%E0%A4%BE%20%E0%A4%A4%E0%A5%8B%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%8B%204%25%20commission%20%E0%A4%A6%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%E0%A4%9C%E0%A4%BE%E0%A4%AF%E0%A5%87%E0%A4%97%E0%A4%BE%0A%20%20%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%8B%20%0A%20%20%20%20100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%C2%A0%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%E0%A5%A4%2024%20hours%20support%20https%3A%2F%2Fnkadda.com%2Flogin%2F${user.referral_code}%0A`}
                    href={`whatsapp://send?text=Play%20ludo%20and%20Win%20Cash%20daily%0A24x7%20live%20Support%0ACommission%20Charge%205%25%0AReferral%20Bouns%203%25%20on%20All%20Games%0AInstant%20withdrawal%20Via%20UPI%2FBank%0Ahttps%3A%2F%2Fnkadda.com%2Flogin%2F${user.referral_code}%0ARegister%20Now%20%2C%20My%20refer%C2%A0code%C2%A0is%C2%A0${user.referral_code}`} >
                    <BsWhatsapp className="icons" />
                    <span style={{ marginLeft: "10px" }}>Whatsapp</span>
                  </a>
                  {/* 
                  <a href="#" target="_blank">
                    {" "}
                    <AiFillFacebook className="icons" />
                  </a>

                  <a href="#" target="_blank">
                    <FaTelegramPlane className="icons" />
                  </a>

                  <CopyToClipboard text={referralText}>
                    <button
                      className="bg-green refer-button cxy bg3 "
                      onClick={(e) => copyLink(e)}
                    >
                      <FiCopy className="icons" />
                    </button> */}
                  {/* </CopyToClipboard> */}
                </div>
              </div>
            </div>

            <div className="refer_page_top_main_box_outer ">
              <div className="refer_page_top_main_box">

                <h2 className="profile_headings text-dark text-left">{translations[language].referral}</h2>
              </div>
              <div className="refer_page_top_main_box_inner">
                <FaRegUserCircle size={30} style={{ color: "#007bff", margin: "" }} />
                <div className="refer_page_top_main_box_inner_single bo_le">

                  <h3 className="text-dark" style={styles}>{translations[language].referPerson}</h3>

                  <p className="mb-0" style={styles}>{user.referral_user?.length}</p>
                  {/* {console.log(user)} */}
                </div>
                
                
                <CiMoneyBill size={30} style={{ color: "#007bff", marginLeft: "30px" }} />
                <div className="refer_page_top_main_box_inner_single">
                  <h3 style={styles}>{translations[language].referEarn}</h3>
                  <p className="mb-0" style={styles}>₹{user.referral_earning}</p>
                </div>
              </div>
            </div>

            {/* <div style={{ width: "fit-content", marginBottom: "10px" }}>
              <a
                href="https://youtu.be/X0m4MeTRwK4?si=6rsjvpUfNxMs8yUN"
                target="_blank"
              >
                <span
                  className="d-flex align-items-center  btn-md guide_btn"
                  style={{
                    right: "0.5rem",
                    backgroundColor: "#003441",
                    color: "white",
                    borderRadius: "4px",
                    padding: "4px 13px",
                    fontSize: "12px",
                  }}
                >
                  Youtube
                  <img
                    className="ml-2"
                    src={"/images/Homepage/youtube.png"}
                    alt=""
                    width="15px"
                  />
                </span>
              </a>
            </div> */}



            {/* <div className="refer_page_top_main_box_outer mt-5">
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings">How It Works</h2>
              </div>
              <div className="refer_page_top_main_box_inner">
                <div className="refer_rules">
                  <p>
                    1. You can refer and Earn Win 3% and Loss 1% of your
                    referral winning, every time
                  </p>
                  <p>
                    2. Like if your player plays for NKADDA Coin. 10000 and
                    wins, You will get NKADDA Coin. 300 as referral amount.
                  </p>
                </div>
              </div>
            </div> */}
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
